<template>
	<div>
		<el-container >
			<el-aside width="250px">
				<LocationTree @getTreeData="locationTreeNodeClick"/>
			</el-aside>

			<el-container>
				<el-header >
					<el-form :inline="true" >
						<el-form-item>
							<el-input
									v-model="searchForm.code"
									placeholder="人员编号"
									clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-input
									v-model="searchForm.name"
									placeholder="姓名"
									clearable
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-button @click="getPinWhiteList">搜索</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="addWhiteList">添加</el-button>
						</el-form-item>

						<el-form-item>
							<el-popconfirm title="这是确定批量删除吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item>

						<!-- <el-form-item>
							<el-popconfirm title="确定重新下传（卡片\密码\指纹）吗？" @confirm="delHandle(null)">
								<el-button type="primary" slot="reference" :disabled="delBtlStatu">重新下传</el-button>
							</el-popconfirm>
						</el-form-item> -->
					</el-form>
				</el-header>

				<el-main>
					<el-table
							ref="multipleTable"
							:data="tableData"
							tooltip-effect="dark"
							style="width: 100%; margin-top: -20px;"
							:height="tableHeight"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '8px'}"
							:header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
							border
							stripe
							@selection-change="handleSelectionChange">

						<el-table-column
								type="selection"
								width="55">
						</el-table-column>

						<el-table-column
								prop="locationFullName"
								label="位置"
								width="250">
						</el-table-column>

						<el-table-column
								prop="personNo"
								label="人员号"
								width="150">
						</el-table-column>

						<el-table-column
								prop="personName"
								label="姓名"
								width="150">
						</el-table-column>

						<el-table-column
								prop="personSex"
								label="性别"
								width="70"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="deptFullName"
								label="部门"
								show-overflow-tooltip>
						</el-table-column>
						
						<el-table-column
								prop="beginDate"
								label="开始日期"
								width="120"
								show-overflow-tooltip>
						</el-table-column>

						<el-table-column
								prop="endDate"
								label="结束日期"
								width="120"
								show-overflow-tooltip>
						</el-table-column>
					</el-table>

					<el-pagination
							@size-change="handleSizeChange"
							@current-change="handleCurrentChange"
							layout="total, sizes, prev, pager, next, jumper"
							:page-sizes="[10, 20, 50, 100, 500, 1000]"
							:current-page="current"
							:page-size="size"
							:total="total">
					</el-pagination>
				</el-main>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
				title="位置名单授权"
				:visible.sync="dialogVisible"
				width="1000px"
				:before-close="handleClose"
				:close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-container style="margin-top: -20px;">
					<el-aside width="250px">
						<el-tree
							:data="permTreeData"
							:style="{height: '470px',overflow:'auto'}"
							show-checkbox
							:check-strictly="true"
							ref="permTree"
							node-key="id"
							default-expand-all
							:props="defaultProps">
						</el-tree>
					</el-aside>
					<el-main>
						<el-form :inline="true" style="margin-top: -20px;">
							<el-form-item prop="deptId" label-width="100px">
								<el-select v-model="searchPersonForm.deptId" placeholder="请选择部门" >
									<el-option 
										:value="searchPersonForm.deptId"
										:label="searchPersonForm.fullName"
										style="width: 460px;height: 200px;overflow: auto;background-color: #fff;">
											<DeptTree @getTreeData="deptSelectNodeClick"/>
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-input
										v-model="searchPersonForm.code"
										placeholder="人员号"
										clearable
										style="display: block; width: 150px;"
								>
								</el-input>
							</el-form-item>
							<el-form-item>
								<el-input
										v-model="searchPersonForm.name"
										placeholder="姓名"
										clearable
										style="display: block; width: 150px;"
								>
								</el-input>
							</el-form-item>

							<el-form-item>
								<el-button @click="getPersonList">搜索</el-button>
							</el-form-item>
						</el-form>
						<el-table
						    class="show_table"
							ref="personTable"
							:data="personData"
							height="370"
							tooltip-effect="dark"
							:row-style="{height: '0px'}"
							:cell-style="{padding: '6px'}"
							:header-cell-style="{background: '#E6F2FE', height:'5px',padding:'5px'}"
							border
							stripe
							@selection-change="handlePersonSelectionChange">

							<el-table-column
									type="selection"
									width="55">
							</el-table-column>

							<el-table-column
									prop="personNo"
									label="人员号"
									width="100">
							</el-table-column>

							<el-table-column
									prop="personName"
									label="姓名"
									width="100">
							</el-table-column>

							<el-table-column
									prop="personSex"
									label="性别"
									width="70"
									show-overflow-tooltip>
									<template slot-scope="scope">
									<el-tag size="small" v-if="scope.row.personSex === 1" type="success">男</el-tag>
									<el-tag size="small" v-else-if="scope.row.personSex === 0" type="danger">女</el-tag>
									<el-tag size="small" v-else type="danger">未知</el-tag>
								</template>
							</el-table-column>

							<el-table-column
									prop="identityName"
									label="身份"
									width="100"
									show-overflow-tooltip>
							</el-table-column>

							<el-table-column
									prop="fullName"
									label="部门"
									show-overflow-tooltip>
							</el-table-column>

						</el-table>
						<el-form-item label="有效日期" label-width="100px" style="margin-top: 10px;">
							<el-date-picker 
								v-model="validDate" 
								type="daterange" 
								value-format="yyyy-MM-dd"
								unlink-panels
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期">
							</el-date-picker>
							<!-- <el-input v-model="editForm.endDate" autocomplete="off"></el-input> -->
							<!-- <el-date-picker v-model="editForm.beginDate" type="date" placeholder="选择开始日期"></el-date-picker>
							<el-date-picker v-model="editForm.endDate" type="date" placeholder="选择结束日期"></el-date-picker> -->
						</el-form-item>
					</el-main>
				</el-container>
				<!-- <el-form-item>
					<el-button type="primary" @click="saveWhiteListHandle">保存</el-button>
					<el-button @click="resetForm('editForm')">取消</el-button>
				</el-form-item> -->
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="saveWhiteListHandle">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
import DeptTree from '../base/DeptTree.vue'
	import LocationTree from "../base/LocationTree.vue"
	export default {
		name: "WhiteList",
		components:{LocationTree, DeptTree},
		data() {
			return {
				searchForm: {},
				searchPersonForm: {},
				delBtlStatu: true,

				total: 0,
				size: 10,
				current: 1,

				dialogVisible: false,
				editForm: {
					beginDate: '',
					endDate: ''
				},
				locationForm: {

				},

				tableData: [],
				personData: [],
				machineData: [],

				treeSelectLocationId: 0,
				selectedMachineId:'',
				selectedMachineInfo:'',

				editFormRules: {
					validDate: [
						{required: true, message: '请选择有效日期范围', trigger: 'blur'}
					]
				},

				multipleSelection: [],
				multiplePersonSelection: [],

				permDialogVisible: false,
				permForm: {},
				defaultProps: {
					children: 'children',
					label: 'locationName'
				},
				permTreeData: [],
				treeSelectDeptId: 0,
				validDate: []
			}
		},
		computed: {
			tableHeight: function() {
				return screen.height > 900 ? 630: 550
			},
			listHeight: function() {
				return screen.height > 900 ? 646: 566
			}
		},
		created() {
			// this.getPinWhiteList()
			this.$axios.get('/base/location/list').then(res => {
				this.permTreeData = res.data.data
			})
		},
		methods: {
			toggleSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			handleSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multipleSelection = val;

				this.delBtlStatu = val.length == 0
			},
			handlePersonSelectionChange(val) {
				console.log("勾选")
				console.log(val)
				this.multiplePersonSelection = val;
			},
			locationTreeNodeClick(locationdata) {
				this.treeSelectLocationId = locationdata.id;
				this.getPinWhiteList();
			},

			machineRowClick(row) {
				console.log('row', row);
				this.selectedMachineId = row.id;
				this.selectedMachineInfo = row.locationFullName + "[" + row.machineNum + "(" + row.machineNo + "号机)] 名单授权";
				this.getPinWhiteList();
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.size = val
				this.getPinWhiteList()
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.current = val
				this.getPinWhiteList()
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.dialogVisible = false
				this.editForm = {}
			},
			handleClose() {
				this.resetForm('editForm')
			},
			locationSelectNodeClick(locationdata) {
				this.$set(this.locationForm, "locationId", locationdata.id);
				this.$set(this.locationForm, "locationFullName", locationdata.fullName);
				this.getMachineList();
				// console.log(deptdata);
			},
			deptSelectNodeClick(deptdata) {
				this.treeSelectDeptId = deptdata.id;
				this.$set(this.searchPersonForm, "deptId", deptdata.id);
				this.$set(this.searchPersonForm, "fullName", deptdata.fullName);
				this.getPersonList();
			},

			getPersonList() {
				this.$axios.get("/base/person/list", {
					params: {
						code: this.searchPersonForm.code,
						name: this.searchPersonForm.name,
						deptId: this.treeSelectDeptId,
						current: 0,
						size: 10000
					}
				}).then(res => {
					this.personData = res.data.data.records
				})
			},

			getPinWhiteList() {
				this.$axios.get("/pin/whitelist/list", {
					params: {
						code: this.searchForm.code,
						name: this.searchForm.name,
						locationId: this.treeSelectLocationId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.tableData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			getMachineList() {
				this.$axios.get("/iot/machine/list", {
					params: {
						name: "",
						locationId: this.locationForm.locationId,
						current: this.current,
						size: this.size
					}
				}).then(res => {
					this.machineData = res.data.data.records
					this.size = res.data.data.size
					this.current = res.data.data.current
					this.total = res.data.data.total
				})
			},

			addWhiteList() {
				//添加白名单
				// if (this.treeSelectLocationId === 0) {
				// 	this.$message({
				// 		showClose: true,
				// 		message: '请先选择位置',
				// 		type: 'warning',
				// 		onClose:() => {
				// 			this.getPinWhiteList()
				// 		}
				// 	});
				// } else {
				// 	this.dialogVisible = true
				// }
				this.dialogVisible = true

			},

			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						console.log(this.editForm);
						this.$axios.post('/pin/whitelist/' + (this.editForm.id?'update' : 'save'), this.editForm)
							.then(res => {

								this.$message({
									showClose: true,
									message: '恭喜你，操作成功',
									type: 'success',
									onClose:() => {
										this.getPinWhiteList()
									}
								});

								this.dialogVisible = false
								this.resetForm(formName)
							})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			editHandle(id) {
				this.$axios.get('/pin/whitelist/info/' + id).then(res => {
					this.editForm = res.data.data

					this.dialogVisible = true
				})
			},
			delHandle(id) {

				var ids = []

				if (id) {
					ids.push(id)
				} else {
					this.multipleSelection.forEach(row => {
						ids.push(row.id)
					})
				}

				console.log(ids)

				this.$axios.post("/pin/whitelist/delete", ids).then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose:() => {
							this.getPinWhiteList()
						}
					});
				})
			},
			saveWhiteListHandle() {

				console.log("this.validDate[0]", this.validDate[0]);

				var locationIds = this.$refs.permTree.getCheckedKeys()

				var personIds = []

				this.multiplePersonSelection.forEach(row => {
					personIds.push(row.id)
				})

				var params = {
					locationIdList: locationIds,
					personIdList: personIds,
					beginDate: this.validDate[0],
					endDate: this.validDate[1]
				}

				this.$axios.post("/pin/whitelist/save", params)
				.then(res => {
					this.$message({
						showClose: true,
						message: '恭喜你，操作成功',
						type: 'success',
						onClose:() => {
							this.getPinWhiteList()
						}
					});
					this.dialogVisible = false
				})

				// this.$axios.post('/pin/whitelist/save' + this.selectedMachineId, personIds).then(res => {
				// 	this.$message({
				// 		showClose: true,
				// 		message: '恭喜你，操作成功',
				// 		type: 'success',
				// 		onClose:() => {
				// 			this.getPinWhiteList()
				// 		}
				// 	});
				// 	this.dialogVisible = false
				// })
			},
			clearPhoto(formName) {
				formName.photoUrl = ""
			},
			tableRowStyleName ({row}) {
				if (this.selectedMachineId == row.id) {
					return 'background-color: #E0E0E0 !important;';
				}
			}
		}
	}
</script>

<style scoped>

	.el-pagination {
		float: right;
		margin-top: 22px;
	}
	.el-select {
		width: 100%;
	}
	.el-table .warning-row {
		background: pink!important;
	}
	.show_table {
		position: relative;
		width: 100%;
		height: 370px;
		overflow: auto;
		margin-top: -15px;
	}
</style>